export const mutations = {
  GET_PROVIDER_GAMES: (state) => {
    state.loading = true;
  },
  GET_PROVIDER_GAMES_SUCCESS: (state, response) => {
    state.games = response.games;
    state.loading = false;
  },
  GET_PROVIDER_GAMES_FAILURE: (state, { error }) => {
    state.loading = false;
    state.responseError = error;
  },
  GET_PROVIDER_INFO_FOR_EDIT: (state) => {
    state.loading = true;
  },
  GET_PROVIDER_INFO_FOR_EDIT_SUCCESS: (state, response) => {
    state.profile = response.profile;
    state.announcements = response.announcements;
    state.games = response.games;
    state.services = response.services;
    state.availability = response.availability;
    state.loading = false;
  },
  GET_PROVIDER_INFO_FOR_EDIT_FAILURE: (state, { error }) => {
    state.loading = false;
    state.responseError = error;
  },
  UPDATE_AVAILABILITY: (state) => {
    state.availabilityLoading = true;
  },
  UPDATE_AVAILABILITY_SUCCESS: (state, { availability }) => {
    state.availability = availability;
    state.availabilityLoading = false;
  },
  UPDATE_AVAILABILITY_FAILURE: (state, { error }) => {
    state.availabilityLoading = false;
    state.responseError = error;
  },
  UPDATE_PUBLIC_PROFILE: (state) => {
    state.profileLoading = true;
  },
  UPDATE_PUBLIC_PROFILE_SUCCESS: (state, { profile }) => {
    state.profile = profile;
    state.profileLoading = false;
  },
  UPDATE_PUBLIC_PROFILE_FAILURE: (state, { error }) => {
    state.profileLoading = false;
    state.responseError = error;
  },
  ADD_OR_UPDATE_SERVICE: (state) => {
    state.servicesLoading = true;
  },
  ADD_OR_UPDATE_SERVICE_SUCCESS: (state, { service }) => {
    let isCreated = true;
    state.servicesLoading = false;
    state.services = state.services.map((e) => {
      if (e.id.toString() === service.id.toString()) {
        isCreated = false;
        return service;
      } else {
        return e;
      }
    });
    if (isCreated) {
      state.services = [...state.services, service];
    }
  },
  ADD_OR_UPDATE_SERVICE_FAILURE: (state, { error }) => {
    state.servicesLoading = false;
    state.responseError = error;
  },
  REMOVE_SERVICE: (state) => {
    state.servicesLoading = true;
  },
  REMOVE_SERVICE_SUCCESS: (state, { removedId }) => {
    state.services = state.services.filter((e) => e.id !== removedId);
    state.servicesLoading = false;
  },
  REMOVE_SERVICE_FAILURE: (state, { error }) => {
    state.servicesLoading = false;
    state.responseError = error;
  },
  ADD_OR_UPDATE_GAME: (state) => {
    state.gamesLoading = true;
  },
  ADD_OR_UPDATE_GAME_SUCCESS: (state, { game }) => {
    let isCreated = true;
    state.gamesLoading = false;
    state.games = state.games.map((e) => {
      if (e.id.toString() === game.id.toString()) { // @alert: post response contains string type of id
        isCreated = false;
        return game;
      } else {
        return e;
      }
    });
    if (isCreated) {
      state.games = [...state.games, game];
    }
  },
  ADD_OR_UPDATE_GAME_FAILURE: (state, { error }) => {
    state.gamesLoading = false;
    state.responseError = error;
  },
  REMOVE_GAME: (state) => {
    state.gamesLoading = true;
  },
  REMOVE_GAME_SUCCESS: (state, { removedId }) => {
    state.games = state.games.filter((e) => e.id.toString() !== removedId.toString());
    state.gamesLoading = false;
  },
  REMOVE_GAME_FAILURE: (state, { error }) => {
    state.gamesLoading = false;
    state.responseError = error;
  },
  ADD_OR_UPDATE_ANNOUNCEMENT: (state) => {
    state.announcementsLoading = true;
  },
  ADD_OR_UPDATE_ANNOUNCEMENT_SUCCESS: (state, { announcement }) => {
    let isCreated = true;
    state.announcementsLoading = false;
    state.announcements = state.announcements.map((e) => {
      if (e.id.toString() === announcement.id.toString()) {
        isCreated = false;
        return announcement;
      } else {
        return e;
      }
    });
    if (isCreated) {
      state.announcements = [...state.announcements, announcement];
    }
  },
  ADD_OR_UPDATE_ANNOUNCEMENT_FAILURE: (state, { error }) => {
    state.announcementsLoading = false;
    state.responseError = error;
  },
  REMOVE_ANNOUNCEMENT: (state) => {
    state.announcementsLoading = true;
  },
  REMOVE_ANNOUNCEMENT_SUCCESS: (state, { removedId }) => {
    state.announcements = state.announcements.filter((e) => e.id.toString() !== removedId.toString());
    state.announcementsLoading = false;
  },
  REMOVE_ANNOUNCEMENT_FAILURE: (state, { error }) => {
    state.announcementsLoading = false;
    state.responseError = error;
  },
  GET_INCOMING_ORDERS: (state) => {
    state.loading = true;
  },
  GET_INCOMING_ORDERS_SUCCESS: (state, response) => {
    state.incomingOrders = response;
    state.loading = false;
  },
  GET_INCOMING_ORDERS_FAILURE: (state, { error }) => {
    state.loading = false;
    state.responseError = error;
  },
  GET_ALLOWED_GAMES: (state) => {
    state.loading = true;
  },
  GET_ALLOWED_GAMES_SUCCESS: (state, response) => {
    state.allowedGames = response.allowed_games;
    state.loading = false;
  },
  GET_ALLOWED_GAMES_FAILURE: (state, { error }) => {
    state.loading = false;
    state.responseError = error;
  },
  GET_LOBBY_SESSIONS: (state) => {
    state.loading = true;
  },
  GET_PROVIDER_LOBBY_SESSIONS_SUCCESS: (state, response) => {
    state.providerLobbySessions = response.data;
    state.loading = false;
  },
  GET_CONSUMER_LOBBY_SESSION_SUCCESS: (state, response) => {
    state.consumerLobbySessions = response.data;
    state.loading = false;
  },
  GET_LOBBY_SESSIONS_FAILURE: (state, { error }) => {
    state.loading = false;
    state.responseError = error;
  },
  UPDATE_PROVIDER_LOBBY_SESSION: (state, response) => {
    state.providerLobbySessions = {
      ...state.providerLobbySessions,
      ...response.data,
    };
    state.loading = false;
  },
  UPDATE_CONSUMER_LOBBY_SESSION: (state, response) => {
    state.consumerLobbySessions = {
      ...state.consumerLobbySessions,
      ...response.data,
    };
    state.loading = false;
  },
  UPDATE_EDITTING_LOBBY_SESSION: (state, data) => {
    state.edittingLobbySession = data;
  },
};
